import dayjs from 'dayjs'

import {
  HouseOptionsGlobal,
  HouseOptionsIndividual,
  HouseOptionsSeasonPrice,
  HouseSeasonalBusynessCalendarMonth,
  HouseSeasonalBusynessCalendarMonths,
} from '../../../../../../../lib/graphql'

export const isWeekEnd = ({ date }: { date: Date }): boolean => {
  const day = dayjs(date).day()

  return day === 5 || day === 6
}

export const isFirstHalfOfMonth = ({ date }: { date: Date }): boolean => {
  const day = dayjs(date).date()

  return day <= 15
}

/**
 * Get price key from date eg. lowPrice, mediumPrice, highPrice
 */
export const getSeasonPriceKey = ({
  date,
  options,
}: {
  date: Date
  options: HouseOptionsGlobal | HouseOptionsIndividual
}): keyof Omit<HouseOptionsSeasonPrice, '__typename'> => {
  const verboseMonth = getSeasonalBusynessKey({ date })

  const monthData: HouseSeasonalBusynessCalendarMonth =
    options.seasonalBusynessCalendar[0].months[verboseMonth]

  const season = `${isFirstHalfOfMonth({ date }) ? monthData.firstHalf : monthData.secondHalf}`

  const priceKey = `${season.toLowerCase()}Price`

  return priceKey as keyof Omit<HouseOptionsSeasonPrice, '__typename'>
}

/**
 * Get month name in lowercase (e.g., 'january')
 */
export const getSeasonalBusynessKey = ({
  date,
}: {
  date: Date
}): keyof Omit<HouseSeasonalBusynessCalendarMonths, '__typename'> => {
  const seasonalBusynessKey = dayjs(date)
    .locale('en')
    .format('MMMM')
    .toLowerCase() as keyof Omit<
    HouseSeasonalBusynessCalendarMonths,
    '__typename'
  >

  return seasonalBusynessKey
}
